import React from 'react';
import {observer} from 'mobx-react';
import {
  Layout,
  AvatarPanel,
  Display,
  Panel,
  Table,
  EmployeeNameWithAvatar,
  ActionLink
} from 'components';
import {t, withState} from 'shared/core';
import {RevieweeResultsState} from '../state';
import {ReviewReader} from '../../review_details';
import ReviewerDetails from '../../ReviewerDetails';
import {FormattedMessage} from 'react-intl';
import CompletedIcon from 'img/list-element-complete@2x.png';
import IncompleteIcon from 'img/list-element-incomplete-default@2x.png';

const EmptyResults = () => {
  return (
    <div className='py4 center' style={{border: '2px dashed #C9CFD1'}}>
      <div className='h1 black medium pt4 mt3'>
        <FormattedMessage id='performance_reviews.view.Results are on the way.'/>
      </div>
      <div className='h3 jumbo pt2 pb4 mb3'>
        <FormattedMessage id="performance_reviews.view.Reviews have not been submitted for this employee."/>
      </div>
    </div>
  );
};

const StatusCheckmark = observer(({status}) => {
  return (
    <div className='center'>
      <img src={status ? CompletedIcon : IncompleteIcon} width='18' alt='complete'/>
    </div>
  );
});

const PrintFriendlyActionLink = observer(() => {
  return (
    <ActionLink className='h4' onClick={() => window.print()}>
      <FormattedMessage id='performance_reviews.view.Printer friendly version'/>
      <i className='material-icons h3 ml1 align-middle inline'>{'print'}</i>
    </ActionLink>
  );
});

const COLUMNS = [
  {
    header: 'performance_reviews.view.Name',
    width: 8,
    render: model => <EmployeeNameWithAvatar employee={model.reviewer}/>
  },
  {
    header: 'performance_reviews.view.Submitted',
    width: 4,
    render: model => <StatusCheckmark status={model.status} />
  }
];

const ReviewersPanel = observer(({uiState}) => {
  const {reviewersWithStatus} = uiState;

  return (
    <Panel className='clearfix my2 print-hide'>
      <Panel.Header title={t('performance_reviews.view.Reviewers')} />
      <Table
        columns={COLUMNS}
        models={reviewersWithStatus}
        showLinks={false}
        indexBy='reviewer.id'
        onRowClicked={model => uiState.scrollToReview(model)}
      />
    </Panel>
  );
});

const RevieweeResultsContainer = observer(({uiState, match, cycle}) => {
  const {revieweeEmployee, reviewsWithAnswers, hasReviews} = uiState;
  const {backPath, backTitle} = uiState.getBackButtonDetails(match.params);

  return (
    <div>
      <Display
        module
        title={cycle.name}
        backTitle={t(backTitle)}
        backPath={backPath}
        toolbar={<PrintFriendlyActionLink/>}
      />
      <Layout>
        <Layout.Section secondary>
          <AvatarPanel employee={revieweeEmployee}/>
          <ReviewersPanel uiState={uiState} />
        </Layout.Section>
        <Layout.Section>
          {!hasReviews && <EmptyResults/>}
          <Panel.Stack className='fs-hide'>
            {hasReviews && reviewsWithAnswers.map(r =>
              <div key={r.id} id={r.id} ref={e => uiState.addRef(e)}>
                <ReviewReader review={r}
                  title={<ReviewerDetails reviewer={r.reviewer} reviewType={r.type.kind}/>}/>
              </div>
            )}
          </Panel.Stack>
        </Layout.Section>
      </Layout>
    </div>
  );
});

export default withState(RevieweeResultsContainer, RevieweeResultsState);
